<template>
  <div class="home">
    <div class="Tmenu">
      <topMenu></topMenu>
    </div>
    <div class="main">
        <router-view></router-view>
 
     <div>
     </div>
    </div>
     <div class="footer">V1.1</div>
  </div>
</template>
<script>
import topMenu from '@/components/topMenu.vue'
import homeMenu from '@/components/homeMenu.vue'
export default {
  components:{
    topMenu,
    homeMenu,
  },
  
}
</script>
<style scoped>
.home{
  /* background: #F4F5F5; */
  /* height: 100vh; */
}
.Tmenu{
  position: fixed;
  width: 100%;
  top:0px;
  height: 100px;
  z-index: 10;
}
.main{
  /* margin:20px auto; */
  /* width:1200px; */
  /* height: 100vh; */
  background: white;
  background: url("../assets/index/indexBackg4.png") no-repeat bottom;
  background-size: 100% auto;
  background-attachment: fixed;
 /* overflow: auto; */
}
.footer {
  background: #2d76f9;
  height: 30px;
  width: 100%;
  min-width: 1200px;
  position: fixed;
  bottom: 0px;
  left: 0px;
  color: #0095ff;
  text-align: left;
  z-index: 100;
}

/* .main>div:nth-child(1){

  background: white;
    height: 80vh;

} */
</style>
<style>
.tableBox > .el-divider > .el-divider__text {
  background-color: #f8fbff;
}
</style>